import Instance from "../../../Axios";

const GetPlusPlanos = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/planos`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_PLANOS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusPlanos;
